var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-breadcrumbs',{staticClass:"py-0 pl-2",attrs:{"items":_vm.items,"divider":">"}}),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }